<template>
    <b-form-group
        :id="name"
        :label="label"
        :label-for="name">
        <b-form-radio :value="value" :id="name"
                      :name="name" @input="$emit('input', $event)">
            {{ label }}
        </b-form-radio>
    </b-form-group>
</template>

<script>
export default {
    name: 'radio',
    props: ['placeholder', 'label', 'name', 'value']
}

</script>